import React from "react";
import { useLang } from "../../translations";
import { FadeUp } from "./Reveal";

const DOCTOR = "https://customer-assets-wrfwihn1.emergentagent.net/job_riviera-homeopathy/artifacts/1906i7oc_20260828_155147%281%29.webp";
const BOTANICAL = "https://images.unsplash.com/photo-1611255550543-b5ecb01dfddc?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

export const About = () => {
  const { t } = useLang();
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-36 bg-cream">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <FadeUp>
            <div className="relative">
              <div className="img-zoom-wrap rounded-[1.5rem] overflow-hidden aspect-[4/5]">
                <img src={DOCTOR} alt={t.about.title} className="h-full w-full object-cover" />
              </div>
              <div className="img-zoom-wrap absolute -bottom-8 -right-4 md:-right-8 w-32 h-40 md:w-40 md:h-52 rounded-[1.25rem] overflow-hidden border-[6px] border-cream shadow-xl">
                <img src={BOTANICAL} alt="botanical" className="h-full w-full object-cover" />
              </div>
            </div>
          </FadeUp>
        </div>

        <div className="lg:col-span-7">
          <FadeUp>
            <p className="text-xs uppercase tracking-[0.28em] text-sage mb-5">{t.about.label}</p>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-[3.4rem] text-ink leading-[1.05] tracking-tight">
              {t.about.title}
            </h2>
          </FadeUp>
          <FadeUp delay={0.1}>
            <p className="mt-8 text-lg text-muted2 leading-relaxed">{t.about.p1}</p>
            <p className="mt-5 text-lg text-muted2 leading-relaxed">{t.about.p2}</p>
          </FadeUp>
          <FadeUp delay={0.2}>
            <div className="mt-12 grid grid-cols-3 gap-6 border-t border-ink/10 pt-8">
              {t.about.stats.map((s, i) => (
                <div key={i} data-testid={`about-stat-${i}`}>
                  <p className="font-heading text-3xl md:text-4xl text-sage">{s.n}</p>
                  <p className="text-sm text-muted2 mt-1">{s.l}</p>
                </div>
              ))}
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
